<script setup lang="ts">
import {Check, X} from '@lucide/vue';

defineProps<{
    state: "done" | "to-do",
    title: string;
}>();
</script>

<template>
  <div class="border rounded-lg border-black pt-4 px-4 pb-2 space-y-1">
    <div class="flex items-start gap-4">
      <div>
        <Check v-if="state === 'done'" class="size-12 text-secondary stroke-[4px] -my-1" />
        <X v-else class="size-12 text-red stroke-[3px] -my-1" />
      </div>
      <div class="space-y-1">
        <p class="leading-none">
          {{ title }}
        </p>
        <p class="text-sm text-gray-500">
          <slot name="latest" />
        </p>
      </div>
    </div>
    <div class="flex justify-end">
      <slot name="action" />
    </div>
  </div>
</template>

<style scoped>

</style>
